import { baseConfig } from '@/config/_config-base.js'

export default {
  ...baseConfig,
  api: {
    ...baseConfig.api,
    host: `https://api.app.koupserver.at/${baseConfig.api.apiversion}`,
    companionUrl: `https://api.app.koupserver.at/${baseConfig.api.apiversion}`, // we use CORS for uppy companion calls
    websocketServerUrl: 'https://api.app.koupserver.at',
  },
  awsS3BucketHost: 'https://koupserverat.s3-accelerate.amazonaws.com',
  isKoupPlanserver: true,
  headTitleTag: 'Koup Planserver',
  logoPath: new URLsrc/assets/img/customer-theme/koupserverat/koupserverat_logo.png', import.meta.url).href,
  tasksBetaUsers: [], // If an array entry matches with the logged in users email (regex), a user can see the tasks tab
  customerFeatures: {
    ...baseConfig.customerFeatures,
    htmlTagClass: 'theme theme--koupserverat',
    isUserAllowedToCreateNewProject: email => {
      const allowedToCreateNewProject = [
        'server@koup.at',
        'koupserver_cypress@test.planfredapp.com', // user for cypress tests - do not remove!
        'approver@test.planfredapp.com', // user for cypress tests - do not remove!
      ]

      return allowedToCreateNewProject.map(email => email.toLowerCase())
        .includes(email.toLowerCase())
    }, // all users are allowed to create new projects
  },
}
